import {
  LIST_PARTNER_FAILED,
  LIST_PARTNER_REQ,
  LIST_PARTNER_SUCCESS,
} from "../Constants/partnerConstant";

export const listPartnerReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case LIST_PARTNER_REQ: {
      return { loading: true };
    }
    case LIST_PARTNER_SUCCESS: {
      return { loading: false, partnerRecs: payload };
    }

    case LIST_PARTNER_FAILED: {
      return { loading: false, error: payload };
    }
    default: {
      return state;
    }
  }
};
